import { EventTypes } from 'redux-segment';

import { UPDATE_CASHUP_DATA } from './feUpdateCashupData.types';

const feUpdateCashupData = (data) => ({
  type: UPDATE_CASHUP_DATA,
  data,
  meta: { analytics: EventTypes.track },
});

export default feUpdateCashupData;
